module.exports = __webpack_public_path__ + "img/churchill-cust.615dfad5.jpg";